import { windowScroll } from "@/utils/helper";
import { computed, reactive, readonly } from "vue";
import type { StepState, UseStepStore } from "./type";

const stateDefault: StepState = {
  status: "D",
  isCancel: "N",
  step: 0,
  lastStep: 0,
};

const state = reactive<StepState>({ ...stateDefault });

export function useStepStore(): UseStepStore {
  const isActive = computed(
    () => state.status === "D" && state.isCancel === "N",
  );

  function setState(updates: Partial<StepState>): void {
    if (updates.status) {
      state.status = updates.status;
    }

    if (updates.isCancel) {
      state.isCancel = updates.isCancel;
    }

    if (typeof updates.step === "number" && updates.step >= 0) {
      state.step = updates.step;
      state.lastStep = Math.max(state.step, state.lastStep);
    } else if (updates.step !== undefined) {
      console.warn("Invalid step value. Must be a non-negative number.");
    }
  }

  function nextStep(): void {
    const step = state.step + 1;
    setState({ step });
    windowScroll();
  }

  function previousStep(scroll: boolean = true): void {
    if (state.step > 0) {
      setState({ step: state.step - 1 });
      if (scroll) {
        windowScroll();
      }
    } else {
      console.warn("Cannot go back. Already at the first step.");
    }
  }

  function reset(): void {
    Object.assign(state, { ...stateDefault });
  }

  return {
    state: readonly(state),
    isActive,
    setState,
    nextStep,
    previousStep,
    reset,
  };
}
